import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import verified from "./images/verified.png";
import handShake from "./images/handshake.png";
import tickIcon from "./images/tick.svg";
import medalIcon from "./images/medal.svg";
import checkIcon from "./images/check-circle.svg";
import getCarInfo from "../../../utils/helpers/get-car-info";
import { LEAD_APPOINTMENT_STATUS, LOGIN_SOURCE } from "../../../constants/app-constants";
import { getDealerPage } from "../../../utils/helpers/get-dealer-route";
import { useHistory } from "react-router";
import Button from "../../shared/button";

const DealerVerificationInfo = ({
    content,
    phoneNumberVerified,
    openLoginPopupConnect,
    setOnLoginSuccessCallback,
    leadAppointment,
    createClassifiedLeadConnect,
    dealerInfo,
    handleShowLoggedInDealerRedirect,
    cmsData
}) => {
    const { isDealerListing, dealerCode } = getCarInfo(content) || {};
    const {dealerBadges = [], name: dealerName = ""} = dealerInfo?.[dealerCode || ""] || {};
    const history = useHistory();
    const onCardClick = () => {
        const dealerPage = getDealerPage(dealerName, dealerCode);
        if (!isDealerListing) {
            return;
        }
        if (phoneNumberVerified && leadAppointment?.status === LEAD_APPOINTMENT_STATUS.CONFIRM) {
            history.push(dealerPage);
            return;
        } else if (phoneNumberVerified && leadAppointment?.status !== LEAD_APPOINTMENT_STATUS.CONFIRM) {
            createClassifiedLeadConnect();
            handleShowLoggedInDealerRedirect(dealerPage);
            return;
        } else {
            setOnLoginSuccessCallback(() => {
                history.push(dealerPage);
            });
            openLoginPopupConnect({
                additionalInfo: { loginSource: LOGIN_SOURCE.CLASSISFIEDS, source: "CDP_dealer_profile", appointmentId: content?.appointmentId}
            });
        }

    };
    return (
        <div styleName={"styles.dealerVerificationInfoWrapper"}>
            <p styleName={"styles.dealerVerificationInfoHeading"}>Dealer verification</p>
            <div className="media" styleName={"styles.dealerVerificationInfoCard"}>
                <img src={verified} />
                <div className="media-body">
                    <p styleName={"styles.dealerVerificationHeading"}>{cmsData?.verification?.status || "Verified dealership"}</p>
                    <p styleName={"styles.dealerVerificationSubHeading"}>{cmsData?.verification?.description || "Our identity verification process checks a dealership’s information against trusted third-party"}</p>
                </div>
            </div>
            <div className="media" styleName={"styles.dealerVerificationInfoCard"}>
                <img src={handShake} />
                <div className="media-body">
                    <p styleName={"styles.dealerVerificationHeading"}>{cmsData?.dealer_offerings?.heading || "Dealer offerings"}</p>
                    <div styleName={"styles.pointerWrap"}>
                        {dealerBadges?.map((badge, index) => (
                            <p key={`${badge}-${index}`} styleName={"styles.pointers"}><img src={tickIcon} />{badge}</p>
                        ))}
                    </div>
                </div>
            </div>
            <div className="media" styleName={"styles.dealerVerificationInfoCard"}>
                <img src={medalIcon} />
                <div className="media-body">
                    <p styleName={"styles.dealerVerificationHeading"}>{cmsData?.dealer_quality_promises?.heading || "Dealer quality promises"}</p>
                    <div styleName={"styles.pointerWrap"}>
                        {(cmsData?.dealer_quality_promises?.items?.length ? cmsData?.dealer_quality_promises.items : []).map((promise, index) => (
                            <p key={`${promise}-${index}`} styleName={"styles.dealerPointers"}><img src={checkIcon} />{promise}</p>
                        ))}
                    </div>
                </div>
            </div>
            <Button
                size={"medium"}
                variant={"secondary"}
                onClick={onCardClick}
                text={cmsData?.cta?.text || "See full profile"}
            />
        </div>
    );
};

DealerVerificationInfo.propTypes = {
    config: PropTypes.object,
    metaContent: PropTypes.object,
    content: PropTypes.object,
    phoneNumberVerified: PropTypes.bool,
    openLoginPopupConnect: PropTypes.func,
    setOnLoginSuccessCallback: PropTypes.func,
    leadAppointment: PropTypes.object,
    createClassifiedLeadConnect: PropTypes.func,
    dealerInfo: PropTypes.object,
    handleShowLoggedInDealerRedirect: PropTypes.func,
    cmsData: PropTypes.object

};

export default DealerVerificationInfo;
